// Need to use the React-specific entry point to import createApi
import isBoolean from 'lodash/isBoolean';

import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const messageApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMessages: builder.query({
      query: filters => {
        const qs = new URLSearchParams();
        if (filters.user_to_id) qs.set('user_to_id', filters.user_to_id);
        if (filters.other_user_id) qs.set('other_user_id', filters.other_user_id);
        if (isBoolean(filters.is_read)) qs.set('is_read', filters.is_read);
        if (isBoolean(filters.read_by_me)) qs.set('read_by_me', filters.read_by_me);
        return `message/?${qs}`;
      },
      providesTags: ['Message'],
    }),
    createMessage: builder.mutation({
      query: body => ({
        url: 'message/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['Message', 'Patient'],
    }),
    updateMessage: builder.mutation({
      query: ({ id, body }) => ({
        url: `message/${id}/`,
        method: 'PUT',
        body: body,
      }),
      invalidatesTags: ['Message'],
    }),
    // removeMessage: builder.mutation({
    //   query: ({ id }) => ({
    //     url: `message/${id}/`,
    //     method: 'DELETE',
    //   })
    // }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetMessagesQuery,
  useCreateMessageMutation,
  useUpdateMessageMutation,
  useRemoveMessageMutation
} = messageApi;
